<template>
  <div class="container container-box">
    <div class="list-header">
      <div class="header-line"></div>
      <div class="header-title">{{$t('my.nav.doc')}}</div>
    </div>
    <div class="common-list personal">
        <div class="personal-dynamics">
          <div>{{$t('personal.data.tr')}}<span>{{user['translation']}}</span></div>
          <div>MVP <span>{{user['mvp']}}</span></div>
          <div>{{$t('personal.data.like')}}<span>{{user['liked']}}</span></div>
          <div class="points">
            <div @click="showPoint">
              <img src="../assets/points.png"
                   style="margin-right: 12px;width: 20px;display: inline-block;vertical-align: middle;"
                   alt=""/>
              <span>{{user['point']}}</span>
            </div>
          </div>
        </div>
        <div :class="['personal-userinfo', 'en-personal-userinfo',{'isEngCss':isChinese}]">
          <div class="personal-user userHeadpoirt clearfix">
            <div class="personal-user-title">{{$t('personal.data.headshot')}}</div>
            <div class="file-headpoirt">
              <img :src="user['avatar']"/>
              <!--<a class="btn" @click="toggleShow">上传头像</a>-->
            </div>
          </div>
          <div class="personal-user userName clearfix">
            <div class="personal-user-title">{{$t('personal.data.nickname')}}</div>
            <div class="personal-user-input">
              <input
                style="width: 200px;"
                type="text"
                v-model="username" />
            </div>
          </div>
          <!--<div class="personal-user userAccount clearfix">-->
            <!--<div class="personal-user-title">账号</div>-->
            <!--<div class="personal-user-input">-->

            <!--</div>-->
          <!--</div>-->
          <!--<div class="personal-user userPhone clearfix">-->
            <!--<div class="personal-user-title">手机号</div>-->
            <!--<div class="personal-user-input">-->

            <!--</div>-->
          <!--</div>-->
          <div class="personal-user userUpate clearfix">
            <div class="personal-user-title"></div>
            <div class="update" @click="upData">{{$t('personal.data.upData')}}</div>
          </div>
        </div>
    </div>
    <div>
      <my-upload field="img"
                 @crop-success="cropSuccess"
                 @crop-upload-success="cropUploadSuccess"
                 @crop-upload-fail="cropUploadFail"
                 v-model="show"
                 :width="300"
                 :height="300"
                 url="/upload"
                 :params="params"
                 :headers="headers"
                 img-format="png"></my-upload>
    </div>
    <IconModel  ref="myPoint"></IconModel>
  </div>
</template>
<style scoped>
  @import "../css/list-item.scss";
  .personal{
    padding:0 20px;
  }
  .personal-dynamics{
    height:46px;
    line-height:46px;
    padding:14px 0;
    border-bottom: 1px solid #EBF1ED;
    font-size: 18px;
    color: #666666;
    text-align: center;
    margin-bottom: 30px;
  }
  .personal-dynamics>div{
    float: left;
    width:25%;
    border-right:1px solid #EBF1ED;
    box-sizing: border-box;
  }
  .personal-dynamics>div>span{
    margin-right: 25px;
  }
  .personal-dynamics>div:last-child{
    border-right: none;
  }
  .personal-user{
    padding-left:106px;
    position: relative;
    width:100%;
    box-sizing: border-box;
  }

  .personal-user-title{
    position: absolute;
    left:0;
    font-size: 14px;
    color: #666666;
    width:106px;
    text-align: left;
    min-height:33px;
    line-height:33px;
  }
  .userHeadpoirt{
    margin-bottom: 25px;
  }
  .userName,.userAccount{
    margin-bottom: 39px
  }
  .userPhone{
    margin-bottom: 20px;
  }
  .userUpate .update{
    width:132px;
    height:33px;
    background: #FFFFFF;
    border: 1px solid #5EBB8D;
    line-height:33px;
    text-align: center;
    color: #5EBB8D;
    cursor: pointer;
  }
  .userUpate .update:hover{
    color: #ffffff;
    background: #5EBB8D;
  }
  .points >div{
    width: 110px;
    margin: 5px auto 0;
    height: 20px;
    line-height: 20px;
    background: #5EBB8D;
    color: #fff;
    border-radius: 4px;
    font-size: 14px;
    padding: 7px 0;
    cursor: pointer;
  }
  .personal-user-input{
    background: #FFFFFF;
  }
  .personal-user-input >input {
    display: block;
    width: 100%;
    height: 30px;
    border: 1px solid #C1C1C1;
    padding-left: 10px;
    box-sizing: border-box;
    padding-right: 10px;
  }
  .file-headpoirt>img{
    height: 50px;
    border-radius: 50px;
    vertical-align: middle;
    margin-right: 26px;
  }
  .file-headpoirt>a{
    font-size: 14px;
    color: #5EBB8D;
  }
   @media (max-width:650px){
     .personal-dynamics{
       font-size:14px;
     }
     .personal-dynamics>div{
       width:33.33%;
       border:none;
     }
     .personal-dynamics>div:last-child(2){
       border:none;
     }
      .personal-dynamics>div>span{
        margin-right: 0;
        display:block;
        line-height: 5px;
    }
     .personal-dynamics{
       position: relative;
       padding-bottom: 30px;
     }
     .personal-dynamics>div.points{
      position: absolute;
      right: 0;
      bottom: -70px;
      z-index: 999;
     }
     .personal-user-title{
        width: 50px;
     }
     .personal-user{
       padding-left: 60px;
     }
     .personal-userinfo{
       padding-left: 20px;
       padding-right:20px;
     }
   }
</style>
<script>
  import 'babel-polyfill'; // es6 shim
  import myUpload from 'vue-image-crop-upload';
  import { getUserData, changeUserInfo,logout ,USER_INFO} from '@/api/user';
  import IconModel from '../components/IconModel';
  import Cookies from 'js-cookie';
  import { whatLang } from '@/utils/index'

  export default {
  data() {
    return {
      show: false,
      params: {
        token: '123456798',
        name: 'avatar'
      },
      headers: {
        smail: '*_~'
      },
      imgDataUrl: '',
      user:{},
      username:'',
      isChinese: whatLang() !='zh'
    }
  },
  mounted(){

  },
  components: {
      'my-upload': myUpload,
       IconModel
  },
  created() {
    this.user = USER_INFO();
    if(!this.user['username']){
      this.username = getUserData()['name']
    }else{
      this.username = this.user['username']
    }
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(imgDataUrl, field){
      this.user['avatar']=imgDataUrl;
    },
    cropUploadSuccess(jsonData, field){
      console.log(jsonData);
    },
    cropUploadFail(status, field){
      console.log(status);
    },
    upData(){
        changeUserInfo(this.user['_id'],this.username).then(res=>{
            if (res.rc ===0 ) {
              this.user['username']=this.username;
              let user = Cookies.get('cy_user') || '{}';
              user = JSON.parse(user);
              user['name'] = this.username;
              Cookies.set('cy_user',JSON.stringify(user));
              this.$message({
                type: 'success',
                message: this.$t('personal.upData.ok')
              });
            }else{
              this.$message({
                type: 'error',
                message: this.$t('personal.upData.error')
              });
            }
        })
    },
    showPoint () {
      this.$refs.myPoint.show(this.user['_id']);
    },
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/personal.vue